/* eslint-disable @next/next/no-img-element */
import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import styles from "@/src/styles/home.module.css";

function OnDemandSection(props: { title?: string }) {
  return (
    <Box sx={{ py: 0, padding: { xs: "40px 0 0", sm: "60px 0 0" } }}>
      <Container maxWidth={false} className={"containerWidth"}>
        <div className={styles.demandGridTitle}>
          <h2>Lorem ipsum dolor sit amet</h2>
        </div>
        <div className={styles.demandGridBoxes}>
          <div className={styles.demandBox}>
            <div className={styles.demandBoxImg}>
              <img src={"/images/placeholder.png"} alt={"placeholder"} />
            </div>
            <h3 className={styles.demandBoxTitle}>Header 1</h3>
            <div className={styles.demandBoxText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            </div>
          </div>

          <div className={styles.demandBox}>
            <div className={styles.demandBoxImg}>
              <img src={"/images/placeholder.png"} alt={"placeholder"} />
            </div>
            <h3 className={styles.demandBoxTitle}>Header 2</h3>
            <div className={styles.demandBoxText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            </div>
          </div>

          <div className={styles.demandBox}>
            <div className={styles.demandBoxImg}>
              <img src={"/images/placeholder.png"} alt={"placeholder"} />
            </div>
            <h3 className={styles.demandBoxTitle}>Header 3</h3>
            <div className={styles.demandBoxText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            </div>
          </div>
        </div>
      </Container>
    </Box>
  );
}

export default OnDemandSection;
